<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import InputError from '@/Components/InputError.vue';
import TextInput from '@/Components/TextInput.vue';
import { Link, useForm } from '@inertiajs/vue3';

const props = defineProps({
    landing: String,
    hideRegistrationLink: Boolean
});

const form = useForm({
    email: '',
    landing: props.landing
});

const submit = () => {
    form.post(route('register'));
};
</script>

<template>
    <form @submit.prevent="submit">
        <div>
            <TextInput
                id="email"
                type="email"
                cy-test="email-input"
                class="block w-full pl-4"
                v-model="form.email"
                required
                autocomplete="username"
                placeholder="Enter your email..."
            />

            <InputError class="mt-2" :message="form.errors.email" />
        </div>

        <div class="flex items-center justify-end mt-3">
            <PrimaryButton
                cy-test="register-button"
                type="submit"
                class="h-12 w-full flex items-center justify-center text-white font-bold"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Let's Go!
            </PrimaryButton>
        </div>
    </form>

    <div class="mt-8 text-center md:text-left">
        <p class="text-sm text-gray-500">
            By continuing, you agree to WedPro's
            <Link cy-test="terms-of-service-link" :href="route('legal.termsandconditions')" class="font-bold"
                >Terms of Service</Link
            >
            &
            <Link cy-test="privacy-policy-link" :href="route('legal.privacypolicy')" class="font-bold">Privacy Policy</Link>
        </p>
    </div>

    <p
        v-if="!hideRegistrationLink"
        class="mt-8 text-center text-sm text-gray-500 font-bold hover:text-gray-900 rounded-md focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
    >
        <Link cy-test="already-registered-link" :href="route('login')"> Already registered? Log In </Link>
    </p>
</template>
